import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA — with auto-update detection so users
// don't get stuck on old JavaScript after a redeploy. When a new SW is found
// waiting, we `skipWaiting()` it via postMessage and force a page reload once
// it takes control. That killed the "Approve button does nothing" ghost bug
// caused by legacy cached bundles from before the useConfirm hook fix.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");

      // Detect a waiting worker on first load (already-installed update).
      if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });

      // Detect an update that installs *while* the tab is open.
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            installing.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      // Once the new worker takes control, hard-reload once so the user's
      // running React bundle matches the new server code.
      let refreshed = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshed) return;
        refreshed = true;
        window.location.reload();
      });
    } catch { /* silent — SW is optional */ }
  });
}
